export const SET_DATA = (state, { id, data }) => {
  state[id] = data;
};
export const setList = (state, items) => {
  items.forEach(c => {
    c.isEdit = false;
  });
  state.listCategory = items;
};
export const removeByIndex = (state, index) => {
  state.listCategory.splice(index, 1);
};
export const setNewCat = (state, item) => {
  state.listCategory.push(item);
};
export const setAllsubCategories = (state, items) => {
  items.forEach(c => {
    c.isEdit = false;
  });
  state.allSubCategories = items;
};
export const removeByIndexSubCat = (state, index) => {
  state.allSubCategories.splice(index, 1);
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/category/mutations.js